import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const header = event.currentTarget
    const body = document.getElementById(header.getAttribute('aria-controls'))
    if (!body) return

    const isOpen = header.getAttribute('aria-expanded') === 'true'
    header.setAttribute('aria-expanded', !isOpen)
    body.classList.toggle('open', !isOpen)
  }
}
